<div class="page-container book-management-container container">
  <div class="row w-100 m-0">
    <app-utility-toolbar
      [current]="current"
      [vertical]="true"
      (toggleCollapse)="toggleNavCollapse()"
      class="{{ navCollapsed ? 'w-5' : 'w-15' }} vertical"
      [links]="bmLinks"
    ></app-utility-toolbar>

    <div class="content-container pl-3" [ngClass]="{ collapsed: navCollapsed }">
      @if (current === 'home-office') {
        <app-home-office-reports></app-home-office-reports>
      } @else if (current === 'rep-reports') {
        <app-rep-reports></app-rep-reports>
      } @else if (current !== 'home-office' && current !== 'rep-reports') {
        @if (!policyId) {
          <app-rb-grid
            [gridConfig]="gridConfig"
            [getSetup]="getGridSetup"
            [getData]="getGridData"
          >
            <button
              mat-raised-button
              color="primary"
              class="header-button"
              (click)="downloadPolicyList()"
              [disabled]="fileLoading"
              matTooltip="Limit 100,000"
              matTooltipPosition="above"
            >
              <span class="button-label-with-icon">
                @if (fileLoading) {
                  <mat-spinner diameter="20"></mat-spinner>
                } @else {
                  <mat-icon>cloud_download</mat-icon>
                }
                Download Policy List
              </span>
            </button>
            @if (launchButton && launchButton.ShowLaunchButton) {
              <button
                mat-raised-button
                color="primary"
                class="custom-grid-control me-0 ms-2 mb-2"
                (click)="launchToCase(launchButton.LaunchLocation)"
                [disabled]="disableLaunchTo()"
              >
                <mat-icon>rocket_launch</mat-icon>
                {{ launchButton.LaunchButtonLabel }}
              </button>
            }
          </app-rb-grid>
        } @else {
          <app-policy-details
            [policyId]="policyId"
            [launchButton]="launchButton"
          ></app-policy-details>
        }
      }
    </div>
  </div>
</div>
